import React from 'react';
import News from './News/News';
const MainPage = () => {

  return (
    <News />
  );
};

export default MainPage;
